export default "__VITE_ASSET__BjJXaoeV__"